module.exports = __webpack_public_path__ + "static/img/DSC_0014.d2d92a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/DSC_0014.jpg
// module id = +P0w
// module chunks = 0